var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencyRecommendationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "24mxclzxza",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("path", {
    id: "lpl61t4f6c",
    d: "M0 0h17v25H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EBF1",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g50g02s0pb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#24mxclzxza"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F6F8FA",
    href: "#24mxclzxza"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g50g02s0pb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "buhvdal1yd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#lpl61t4f6c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.052 6.659h-3.987a1.674 1.674 0 0 1-1.675-1.676l.002-4.036H1.677a.729.729 0 0 0-.73.729v21.648a.727.727 0 0 0 .73.729h13.646a.729.729 0 0 0 .73-.729V6.66zM1.677 0h8.685c.226 0 .44.042.642.125.202.084.385.206.544.366l4.96 4.955c.16.16.283.342.367.542l.01.03c.077.193.115.398.115.613v16.693A1.675 1.675 0 0 1 15.323 25H1.677A1.675 1.675 0 0 1 0 23.324V1.676A1.675 1.675 0 0 1 1.677 0z",
    fill: "#9A4CEC",
    mask: "url(#buhvdal1yd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.095 25.811a.474.474 0 1 1 0-.947h5.06a.474.474 0 1 1 0 .947h-5.06zM17.095 28.682a.474.474 0 1 1 0-.947h8.81a.474.474 0 1 1 0 .947h-8.81zM17.095 31.553a.474.474 0 1 1 0-.947h8.81a.474.474 0 1 1 0 .947h-8.81zM17.095 34.423a.474.474 0 1 1 0-.947h8.81a.474.474 0 1 1 0 .947h-8.81z",
    fill: "#9A4CEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyRecommendationIcon);
export default __webpack_public_path__ + "static/media/agencyRecommendationIcon.a6e07cf7503547c67b6195e5b27e9421.svg";
export { ForwardRef as ReactComponent };